module.exports = __webpack_public_path__ + "assets/img/701.0d2a11bb.png";